import "../css/Contact.css";

const Contact = () => {
  return (
    <main className="night-contact">

      {/* INTRO */}
      <section className="contact-intro">
        <h1>Contact</h1>
        <p>
          Come by.<br />
          We’re better in person.
        </p>
      </section>

      {/* MAP */}
      <section className="contact-map">
        <iframe
          title="Neo Café Location"
          src="https://www.google.com/maps?q=coffee%20shop&output=embed"
          loading="lazy"
        />
      </section>

      {/* INFO */}
      <section className="contact-info">
        <div>
          <span>Address</span>
          <p>
            21 Brew Street<br />
            Downtown District<br />
            New York, NY
          </p>
        </div>

        <div>
          <span>Hours</span>
          <p>
            Open Daily<br />
            8:00 PM – 2:00 AM
          </p>
        </div>

        <div>
          <span>Reach Us</span>
          <p>
            hello@neocafe.com<br />
            +1 (555) 234-9876
          </p>
        </div>
      </section>

      {/* CLOSING */}
      <section className="contact-closing">
        <p>
          Coffee tastes different<br />
          when shared after dark.
        </p>
      </section>

    </main>
  );
};

export default Contact;
